// components/Features.js
import React from 'react';
import './Features.css';
import heroImage from "../assets/table.jpeg";

const Features = () => {
  return (
    <section className="features" id="features">
      <div className="features-container">
        <div className="features-header">
          <h2 className="features-title">All Categories of Business Welcome, Come GROW with US!</h2>
          <p className="features-intro">
            Renewed Life meetings build on a variety of networking concepts to create an environment where business owners can interact meaningfully, get to know one another, and form relationships rooted in trust, integrity and professionalism. Our meetings provide opportunities to refine professional conversation and presentation skills, strengthen partnerships, and share referrals that lead to real growth and development in each other’s businesses.
          </p>
        </div>
        
        <div className="features-content">
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-number">01</div>
              <div className="feature-text">
                <h3 className="feature-title">Dedicated Table Networking Time</h3>
                <p className="feature-desc">Focused conversations that build lasting professional relationships.</p>
              </div>
            </div>
            
            <div className="feature-card">
              <div className="feature-number">02</div>
              <div className="feature-text">
                <h3 className="feature-title">Weekly Featured Presentations From Within the Group</h3>
                <p className="feature-desc">Members share expertise, insights, and success stories.</p>
              </div>
            </div>
            
            <div className="feature-card">
              <div className="feature-number">03</div>
              <div className="feature-text">
                <h3 className="feature-title">Future Business Development Workshops</h3>
                <p className="feature-desc">Practical sessions designed to help businesses thrive.</p>
              </div>
            </div>
            
            <div className="feature-card">
              <div className="feature-number">04</div>
              <div className="feature-text">
                <h3 className="feature-title">Delicious Food Served by Burs Restaurant Staff</h3>
                <p className="feature-desc">You may order off the menu and enjoy great food while you connect in a welcoming environment. You can also come early or stay late and enjoy a meal with others. Some of our best connections often happen sharing a meal with others. </p>
              </div>
            </div>
          </div>
          
          <div className="features-image">
            <div className="image-container">
              <img 
                src={heroImage}
                alt="Business meeting" 
                className="feature-img"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Features;
